import { render, staticRenderFns } from "./dr-formio.vue?vue&type=template&id=383539fe&"
import script from "./dr-formio.vue?vue&type=script&lang=js&"
export * from "./dr-formio.vue?vue&type=script&lang=js&"
import style0 from "./dr-formio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports